export const LOG_MESSAGE = "log/message";
